module.exports = __webpack_public_path__ + "img/logo-nextpay-color.2580c6fb.svg";